/**
 * Constants for themes making
 */
export default abstract class Design {

    /** number of columns of depend on count of images in grid */
    public static readonly IMAGE_GRID_COLUMNS_COUNT = [0, 1,2,3, 2,3,3, 3,3,3];

    /** number of columns of depend on count of images in grid */
    public static readonly TILES_GRID_COLUMNS_COUNT = [0, 1,2,3, 2];


    /** breakpoints: CSS example:  min-width: 769px */
    public static readonly BC = {
        xs: 301,
        sm: 481,
        md: 769,
        lg: 1025,
    };
    public static getDeviceSize(): "xxs"|"xs"|"sm"|"md"|"lg"|"xl" {
        const deviceWidth = window.innerWidth;
        if (deviceWidth < this.BC.xs) {
            return "xxs";
        } else if (deviceWidth < this.BC.xs) {
            return "xs";
        } else if (deviceWidth < this.BC.sm) {
            return "sm";
        } else if (deviceWidth < this.BC.md) {
            return "md";
        } else if (deviceWidth < this.BC.lg) {
            return "lg";
        } else {
            return "xl";
        }
    }

    // Backgrounds
    public static readonly backgroundPrimary   = ".has-primary-background";
    public static readonly backgroundSecondary = ".has-secondary-background";
    public static readonly backgroundTertiary  = ".has-tertiary-background";
    public static readonly backgroundDisabled  = ".has-disabled-background";
    public static readonly backgroundSelected  = ".has-selected-background";

    // Font color
    public static readonly colorPrimaryLight   = ".has-light-primary-color";
    public static readonly colorPrimaryDark    = ".has-dark-primary-color";
    public static readonly colorSecondaryLight = ".has-light-secondary-color";
    public static readonly colorSecondaryDark  = ".has-dark-secondary-color";
    public static readonly colorTertiaryLight  = ".has-light-tertiary-color";
    public static readonly colorTertiaryDark   = ".has-dark-tertiary-color";
    public static readonly colorTextMuted      = ".has-grey-text-color";
    public static readonly colorLink           = ".has-link-color";
}
